// extracted by mini-css-extract-plugin
export var label = "_fn-2";
export var slideContainer = "_fn-0";
export var slider = "_fn-1";